<template>
  <v-app>
<!--     <v-btn fab fixed bottom right color="pink" @click="scrollToTop" v-if="pageYOffset >= 1000">
      <v-icon>fa-chevron-up</v-icon>
    </v-btn> -->
    <v-main v-if="this.$func.inAdminPortal() || this.$func.inSellerPortal()">
      <router-view></router-view>
    </v-main>
    <v-main v-else>
      <Notification v-if="!notificationExcludeList.includes($route.name)"></Notification>
      <CustomizeHeader home v-if="!headerExcludeList.includes($route.name)"></CustomizeHeader>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <NavigationBar v-if="!footerExcludeList.includes($route.name)"></NavigationBar>
    </v-main>
    <!-- <Footer v-if="!FooterExcludeList.includes($route.name)"></Footer> -->
    
    <Alert></Alert>
    <AgeReminder></AgeReminder>
    <PeachList></PeachList>
    <ErrorDialog></ErrorDialog>
    <ConfirmDialog></ConfirmDialog>
    <Loading></Loading>
    <Authentication></Authentication>
    <SimpleDialog></SimpleDialog>
    <ProgressLinear></ProgressLinear>
    <Story ref="story"></Story>
  </v-app>
</template>

<script>
import CustomizeHeader from '@/components/CustomizeHeader'
import Footer from '@/components/Footer'
import NavigationBar from '@/components/NavigationBar'
import Alert from '@/components/Alert'
import AgeReminder from '@/components/AgeReminder'
import PeachList from '@/components/PeachList'
import ErrorDialog from '@/components/ErrorDialog'
import ConfirmDialog from '@/components/ConfirmDialog'
import Loading from '@/components/Loading'
import Authentication from '@/components/Authentication'
import Notification from '@/components/Notification'
import SimpleDialog from '@/components/SimpleDialog'
import ProgressLinear from '@/components/ProgressLinear'
import Story from '@/views/Story'
import { mapState, mapGetters } from 'vuex'
export default {
  components: { CustomizeHeader, NavigationBar, Alert, PeachList, AgeReminder, ErrorDialog, ConfirmDialog, Footer, Loading, Authentication, Notification, SimpleDialog, ProgressLinear, Story },
  data() {
    return {
      pageYOffset: window.pageYOffset,
      headerExcludeList: ['Terms', 'Policy', 'Job', 'Chat', 'Chatroom', 'Story', 'HotMore', 'NewcomerMore', 'StoryMore', 'VideoMore', 'PhotoMore', 'Ranking', 'Unlocks', 'SellerBlocks'],
      footerExcludeList: ['Terms', 'Policy', 'Chatroom', 'Story'],
      notificationExcludeList: ['Story'],
      keepAliveList: ['HomePage']
    }
  },
  created() {
    this.$store.dispatch('user/getUserInformation').then(() => {
      if(this.all_verified) {
        this.$store.dispatch('shoppingCart/getShoppingCartProducts')
        this.$store.dispatch('user/getBans')
        this.$store.dispatch('user/getFollowList')
        this.$store.dispatch('user/getBlockList')
        this.$store.dispatch('user/getPurchaseID')
        this.$store.dispatch('user/getLikeID')
      }
    }).catch(() => {
      // 賣家登入或未登入時，取得會員資訊會失敗，這是正常的
    })
    this.$store.dispatch('global/getSellerJobTypes')
    this.$store.dispatch('global/getClothesTypes')
    this.$store.dispatch('global/getVIPDiscount').catch(() => {
      // 未登入時取得 VIP 折扣資訊會失敗，這是正常的
    })
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.pageYOffset = window.pageYOffset
    })
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['all_verified'])
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
  }
};
</script>